import React, { useEffect, useRef, useState } from "react";
import ClockPath from "../assets/christmas/shijian.webp";
import "./countdownLess.less";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
type Props = {
  seconds: number;
  onCountdownFinish: () => void;
};

const CountdownSeconds = (props: Props) => {
  const { t } = useTranslationPlus();
  const { seconds, onCountdownFinish } = props;

  const ref = useRef(seconds);
  const [time, setTime] = useState(seconds);

  useEffect(() => {
    const timer = setInterval(() => {
      update();
    }, 1000);

    const update = () => {
      ref.current = ref.current - 1;
      if (ref.current <= 0) {
        onCountdownFinish();
        clearInterval(timer);
      }
      setTime(ref.current);
    };
    if (seconds === 0 || seconds < 0) {
      onCountdownFinish();
      clearInterval(timer);
    } else {
      update();
    }
    return () => {
      clearInterval(timer);
    };
  }, [seconds]);

  return (
    <div className="redpack-clock">
      <img src={ClockPath} draggable={false}></img>
      <span className="time">{time}</span>
      {/*<span className="text">{t("redpack.Cutdown")}</span>*/}
    </div>
  );
};

export default React.memo(CountdownSeconds);
